// const domain = 'http://localhost:8080';
const domain = null;

interface Caller {
    uri: string;
    method?: string;
    Headers?: any;
    body?: any;
}

export async function fetchAPI(caller: Caller) {
    return fetch((domain || process.env.REACT_APP_PRODUCTION_API) + caller.uri, {
        method: caller.method,
        headers: caller.Headers,
        body: caller.body
    })
        .then(response => {
            return response.json()
        })
        .then(data => {
            console.log('res: ', caller.uri, data);
            return data;
        })
        .catch(error => {
            console.log('Error: ', error);
        });
}